import { FolderSharingLinkKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { extractKey } from "@maven-rest/common/HttpRequest";
import {
  GetFolderFileDocsPdfPageBySharingLinkRequest,
  GetFolderFileDocsPdfPageBySharingLinkResponse,
} from "@maven-rest/docs/FolderSharingLink.dto";
import { FolderSharingLinkUrl } from "@maven-rest/docs/FolderSharingLink.url";

export function useFolderFileDocsPdfPageBySharingLinkQuery(
  req: GetFolderFileDocsPdfPageBySharingLinkRequest,
  options?: SimpleQueryOptions<GetFolderFileDocsPdfPageBySharingLinkResponse, GetFolderFileDocsPdfPageBySharingLinkRequest>
) {
  const fileId = extractKey(req, "fileId");

  return useBaseQuery({
    queryKey: [FolderSharingLinkKey.FolderFileDocsPdfPageBySharingLink, req.accessToken, String(fileId), String(req.docsPdfId), req.page],
    fnOption: { url: FolderSharingLinkUrl.getFolderFileDocsPdfPageBySharingLink(fileId, req.page), request: req },
    ...options,
  });
}
